import  "./Flowchart.css";

const Flowchart = function (props) {
    return(
        <div className="col-12 flowchartWrap">
            <div>
                <div className="iconChart">
                    <img src={ props.data.MOLinkDetailIcon.ImageUrl} data-holder-rendered="true" /> 
                </div>
                <div className="traingle-bottom2"></div>
            </div>
            <div className="flowText">
                <div className="flowTitle">
                    <span className="flowNum">{props.data.ModLinkDetailsOrder+"."}</span>
                    <h3 >{props.data.Title}</h3>
                </div>
                <div className="card-text" dangerouslySetInnerHTML={{__html: props.data.ModLinkSubTitle}}></div>
            </div>
    </div>
    )
}
export default Flowchart;